import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

import { DEFAULT_NAMESPACE, STUDENT_NAMESPACE, studentTerms } from "./utils/studentTerms";
import { resolveUiLocale } from "./constants/languages";

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(studentTerms)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    ns: [DEFAULT_NAMESPACE, STUDENT_NAMESPACE],
    defaultNS: DEFAULT_NAMESPACE,
    postProcess: ["studentTerms"],
    debug: true,
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })
  .then(() => {
    const resolved = resolveUiLocale(
      i18n.language,
      typeof navigator !== "undefined" ? navigator.language : undefined,
    );
    if (resolved && resolved !== i18n.language) {
      return i18n.changeLanguage(resolved);
    }
    return undefined;
  });

export default i18n;
